module.exports = __webpack_public_path__ + "image/login.4f9baa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.png
// module id = 6QGk
// module chunks = 1